$.fn.AxisMove = function(elements) {
  var self = this;

  self.el = {
    elements: elements,
  };
  self.params = {
    x: 75,
    y: 15,
  };

  self.move = function(e)
  {
    let//'s calculate position
      centerX = self.width() / 2,
      centerY = self.height() / 2,
      mouseX = e.pageX - self.offset().left,
      mouseY = e.pageY - self.offset().top,
      coordX = mouseX - centerX,
      coordY = mouseY - centerY,
      moveX = coordX / centerX,
      moveY = coordY / centerY,
      moveQuadX = Math.easeOutQuad(moveX, 0, self.params.x, moveX < 0 ? -1 : 1) * (moveX < 0 ? 1 : -1),
      moveQuadY = Math.easeOutQuad(moveY, 0, self.params.y, moveY < 0 ? -1 : 1) * (moveY < 0 ? 1 : -1);

    /* translate elements accordingly */
    self.el.elements.each(function(){
      $(this).css({
        top: moveQuadY + 'px',
        left: moveQuadX + 'px',
      });
    });
  };

  return function() {
    $(window).on('mousemove', self.move);
    self.data('axismove', true);
    return self;
  }();
};

/* Easing function */
Math.easeOutQuad = function (t, b, c, d) {
  t /= d;
  return -c * t*(t-2) + b;
};
